import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";

export const RadioInput = styled.input`
  position: relative;
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-right: 15px;
  cursor: pointer;
  pointer-events: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transform-origin: center;
  border: 1px solid var(--bg-button);
  border-radius: 50% 50%;
  background-color: transparent;
  transition: 120ms all ease-in-out;

  &::before {
    position: absolute;
    content: "";
    border-radius: 50%;
  }

  &::before {
    top: 3px;
    left: 3px;
    width: 7px;
    height: 7px;
    pointer-events: all;
    transition: 120ms all ease-in-out;
  }

  &:checked {
    transform: scale(1.2);
    transition: background-color 120ms ease-in-out;

    &::before {
      width: 7px;
      height: 7px;
      background: var(--bg-button);
    }
  }

  @media ${device.desktop} {
    margin-right: 7px;
  }
`;

type Props = {
  isShowEmoji: boolean;
};

export const RadioText = styled.span<Props>`
  width: calc(
    100% - 25px - ${({ isShowEmoji }) => (isShowEmoji ? "30px" : "0px")}
  );
  display: inline-block;
  margin-top: -2px;
  text-align: start;

  @media ${device.desktop} {
    width: calc(
      100% - 23px - ${({ isShowEmoji }) => (isShowEmoji ? "30px" : "0px")}
    );
  }
`;

export const RadioLabel = styled.label`
  display: inline-flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 10px;
  border: 0.75px solid var(--bg-back-button);
  border-radius: 3px;
  font-weight: 400;
  font-size: 13px; //11
  line-height: 1.45;
  color: var(--text-color);
  cursor: pointer;
  transition: border 500ms linear;

  &:hover,
  &:focus {
    border: 0.75px solid var(--bg-button);
  }

  @media ${device.desktop} {
    height: auto;
    height: 100%;
    font-size: 13px; //10
    line-height: 1.23; //1.6
  }
`;

export const EmojiBox = styled.span`
  width: 20px;
  height: 20px;
  margin-left: 10px;
  background-color: transparent;
`;
